import $ from 'jquery';
import BaseGateway from '../BaseGateway';

class AbstractCreditCardGateway extends BaseGateway {

    constructor(props) {
        super(props);
        this.capabilities.push('place_order_button', 'checkout_error');
    }

    initialize() {
        super.initialize();
        this.actions.addFilter('get_error_message_selector', this.getErrorMessageSelector.bind(this));
    }

    shouldCreatePaymentMethod() {
        return true;
    }

    getErrorMessageSelector(selector, controller, gatewayId) {
        if (this.id !== gatewayId) {
            return selector;
        }
        if (controller.context.isCheckout() || controller.context.isOrderPay()) {
            selector = this.settings.noticeSelector;
            if (this.settings.noticeLocation === 'bcf') {
                $('.wc-stripe-card-notice').remove();
                $('.wc-stripe_cc-container').append('<div class="wc-stripe-card-notice"></div>');
            }
        }
        return selector;
    }
}

export default AbstractCreditCardGateway;